'use strict';

module.exports = function calculateReturn(investment, rate) {
	return (rate / 100) * investment;
};